export default __webpack_public_path__ + "static/media/investors.05b93e70.jpg";